import { FC } from "react";
import { teamMember } from "../../../types/calendar";
import { Avatar } from "antd";
import { selectedService } from "../../../types/service";
import { UserOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";

interface ServiceProps {
  service: selectedService;
}

const Service: FC<ServiceProps> = ({ service }) => {
  const intl = useIntl();
  return (
    <div className="space-y-2  p-2 border-[1px] border-[#EEF0FF] border-solid rounded border-x-0 border-t-0 my-1">
      <p className="text-color-primary capitalize">{service.name}</p>
      {service.teamMember ? (
        <div className="flex gap-2 items-center">
          <Avatar
            size={30}
            src={service?.teamMember?.media}
            icon={<UserOutlined />}
            className="bg-gray"
          >
            {service?.teamMember?.name?.charAt(0)?.toLocaleUpperCase()}
          </Avatar>
          <p className="text-color-sec-title capitalize">
            {service?.teamMember?.name}
          </p>
        </div>
      ) : null}
      <p className="flex gap-2">
        <span className="text-color-sec-title">
          {service.duration}{" "}
          <small className="text-xs">
            {intl.formatMessage({ id: "mins" })}
          </small>
        </span>
        <span className="text-color-primary">
          {service.price}{" "}
          <small className="text-xs">{intl.formatMessage({ id: "SAR" })}</small>
        </span>
      </p>
    </div>
  );
};

export default Service;
